import React from "react";
import "./App.css";

function App() {
  return <div className="App">Case Management</div>;
}

export default App;
